import Avocado from "../../images/Avocado.png";
import Automobiles from "../../images/Automobiles.png";
import Mining from "../../images/Mining.png";

const questionAnswers = [
  // Avocado Questtions
  // Domestic Graph Questions
  {
    title: "U.S. Avocado Market",
    type: "domestic",
    answer: [1],
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell avocados in the U.S.",
    answerText:
      "The area under the demand curve and above the price represents the gains to consumers from trade. It is the difference between the maximum price they would have been willing to pay for a given quantity and the market price the consumer actually had to pay.",
    notQuiteText: "",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell avocados in the U.S.",
    question: "CONSUMER SURPLUS",
    icon: Avocado,
  },
  {
    title: "U.S. Avocado Market",
    type: "domestic",
    answer: [5],
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell avocados in the U.S.",
    answerText:
      "The area above the supply curve and below the price represents the gains from trade for producers. It is the difference between the minimum price they would have accepted for a given quantity and the price they were actually paid.",
    notQuiteText: "",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell avocados in the U.S.",
    question: "PRODUCER SURPLUS",
    icon: Avocado,
  },

  {
    title: "U.S. Avocado Market",
    type: "domestic",
    answer: [1, 5],
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell avocados in the U.S.",
    answerText:
      "Total surplus is simply the sum of consumer surplus and producer surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of the total surplus from domestic trade.",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell avocados in the U.S.",
    question: "TOTAL SURPLUS",
    icon: Avocado,
  },

  // International Graph Questions
  {
    title: "U.S. Avocado Market",
    type: "international",
    answer: [2, 5, 6, 7],
    answerTextTop:
      "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
    answerText:
      "Consumer surplus expands to the large triangle shown. This expansion is a result of the new, lower price of avocados.",
    notQuiteText:
      "Not quite. You identified part, but not all of consumer surplus.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
    question: "DOMESTIC CONSUMER SURPLUS",
    icon: Avocado,
  },
  {
    title: "U.S. Avocado Market",
    type: "international",
    answer: [8],
    answerTextTop:
      "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
    answerText:
      "The triangle shows the producer surplus area, the amount that producers get above the minimum they would have accepted. Since the price has decreased, producer surplus decreases.",
    notQuiteText: "",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
    question: "DOMESTIC PRODUCER SURPLUS",
    icon: Avocado,
  },
  {
    title: "U.S. Avocado Market",
    type: "international",
    answer: [2, 5, 6, 7, 8],
    answerTextTop:
      "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
    answerText:
      "Total surplus is simply the sum of consumer surplus and producer surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of the total surplus from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
    question: "TOTAL SURPLUS",
    icon: Avocado,
  },
  {
    title: "U.S. Avocado Market",
    type: "international",
    answer: [6, 7],
    answerTextTop:
      "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
    answerText:
      "The triangle shows all of the additional (net) gains created by trading with more efficient avocado producers.",
    notQuiteText:
      "Not quite. You identified part, but not all of the net gains from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
    question: "GAINS FROM INTERNATIONAL TRADE",
    icon: Avocado,
  },

  // US Mining Equipment
  // Domestic
  {
    title: "U.S. Mining Equipment Market",
    type: "domestic",
    answer: [1], //1A
    answerTextTop:
      "Q. U.S. suppliers are able to sell mining equipment only in the U.S",
    answerText:
      "The area under the demand curve and above the price represents the gains to consumers from trade. It is the difference between the maximum price they would have been willing to pay for a given quantity and the market price the consumer actually had to pay.",
    notQuiteText: "",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "U.S. suppliers are able to sell mining equipment only in the U.S.",
    question: "CONSUMER SURPLUS",
    icon: Mining,
  },

  {
    title: "U.S. Mining Equipment Market",
    type: "domestic",
    answer: [5], // 1B
    answerTextTop:
      "Q. U.S. suppliers are able to sell mining equipment only in the U.S.",
    answerText:
      "The area above the supply curve and below the price represents the gains from trade for producers. It is the difference between the minimum price they would have accepted for a given quantity and the price they were actually paid.",
    notQuiteText: "",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "U.S. suppliers are able to sell mining equipment only in the U.S.",
    question: "PRODUCER SURPLUS",
    icon: Mining,
  },

  {
    title: "U.S. Mining Equipment Market",
    type: "domestic",
    answer: [1, 5], //1A,1B
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell mining equipment in the U.S.",
    answerText:
      "Total surplus is simply the sum of consumer surplus and producer surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of the total surplus from domestic trade.",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell mining equipment in the U.S.",
    question: "TOTAL SURPLUS",
    icon: Mining,
  },

  // international 2

  {
    title: "U.S. Mining Equipment Market",
    type: "international2",
    answer: [2], //3A
    answerTextTop:
      "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
    answerText:
      "Unlike the avocados, the U.S. suppliers have a comparative advantage. Consumer surplus shrinks to the triangle shown. This is because domestic consumers now pay a higher price for mining equipment.",
    notQuiteText: "",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "DOMESTIC CONSUMER SURPLUS",
    icon: Mining,
  },

  {
    title: "U.S. Mining Equipment Market",
    type: "international2",
    answer: [4, 5, 6, 9, 10], //3B,3C,3D,3E,3F
    answerTextTop:
      "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
    answerText:
      "Unlike the avocados, the U.S. suppliers have a comparative advantage. The triangle shows the producer surplus area, the amount that producers get above the minimum they would have accepted. Since the price has increased, producer surplus goes up.",
    notQuiteText:
      "Not quite. You identified part, but not all of the domestic producer surplus from domestic trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "DOMESTIC PRODUCER SURPLUS",
    icon: Mining,
  },

  {
    title: "U.S. Mining Equipment Market",
    type: "international2",
    answer: [2, 4, 5, 6, 9, 10], //3A,3B,3C,3D,3E,3F
    answerTextTop:
      "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
    answerText:
      "Total surplus is simply the sum of consumer surplus and producer surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of total surplus from international trade",
    header: "WITH INTERNATIONAL TRADE",
    text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "TOTAL SURPLUS",
    icon: Mining,
  },

  {
    title: "U.S. Mining Equipment Market",
    type: "international2",
    answer: [6], //3D
    answerTextTop:
      "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
    answerText:
      "The triangle shows all of the additional (net) gains created by trading with more efficient mining equipment producers.",
    notQuiteText: "",
    header: "WITH INTERNATIONAL TRADE",
    text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "GAINS FROM INTERNATIONAL TRADE",
    icon: Mining,
  },

  //AutoMobiles
  //Domestic
  {
    title: "U.S. Automobile Market",
    type: "domestic",
    answer: [5],
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell automobiles in the U.S.",
    answerText:
      "The area above the supply curve and below the price represents the gains from trade for producers. It is the difference between the minimum price they would have accepted for a given quantity and the price they were actually paid.",
    notQuiteText: "",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell automobiles in the U.S.",
    question: "PRODUCER SURPLUS",
    icon: Automobiles,
  },

  {
    title: "U.S. Automobile Market",
    type: "domestic",
    answer: [1],
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell automobiles in the U.S.",
    answerText:
      "The area under the demand curve and above the price represents the gains to consumers from trade. It is the difference between the maximum price they would have been willing to pay for a given quantity and the market price the consumer actually had to pay.",
    notQuiteText: "",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell automobiles in the U.S.",
    question: "CONSUMER SURPLUS",
    icon: Automobiles,
  },

  {
    title: "U.S. Automobile Market",
    type: "domestic",
    answer: [1, 5],
    answerTextTop:
      "Q. Only U.S. suppliers are able to sell automobiles in the U.S.",
    answerText:
      "Total surplus is simply the sum of consumer surplus and producer surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of the total surplus from domestic trade.",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell automobiles in the U.S.",
    question: "TOTAL SURPLUS",
    icon: Automobiles,
  },

  //international
  {
    title: "U.S. Automobile Market",
    type: "international",
    answer: [8],
    answerTextTop:
      "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
    answerText:
      "The triangle shows the producer surplus area, the amount that producers get above the minimum they would have accepted. Since the price has decreased, producer surplus decreases.",
    notQuiteText: "",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>”and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "DOMESTIC PRODUCER SURPLUS",
    icon: Automobiles,
  },

  {
    title: "U.S. Automobile Market",
    type: "international",
    answer: [2, 5, 6, 7],
    answerTextTop:
      "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
    answerText:
      "Consumer surplus expands to the large triangle shown. This expansion is a result of the new, lower price of automobiles.",
    notQuiteText:
      "Not quite. You identified part, but not all of consumer surplus.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",

    text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "DOMESTIC CONSUMER SURPLUS",
    icon: Automobiles,
  },

  {
    title: "U.S. Automobile Market",
    type: "international",
    answer: [2, 5, 6, 7, 8],
    answerTextTop:
      "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
    answerText:
      "Total surplus is simply the sum of consumer surplus and producer surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of total surplus from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "TOTAL SURPLUS",
    icon: Automobiles,
  },

  {
    title: "U.S. Automobile Market",
    type: "international",
    answer: [6, 7],
    answerTextTop:
      "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
    answerText:
      "The triangle shows all of the additional (net) gains created by trading with more efficient automobile producers.",
    notQuiteText:
      "Not quite. You identified part, but not all of the net gains from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "GAINS FROM INTERNATIONAL TRADE",
    icon: Automobiles,
  },

  //8, 16 row conflicting answer top text and question
];

export default questionAnswers;
